import React, { useState } from "react";
import {
  TextField,
  Button,
  Typography,
  Paper,
  Grid,
  InputAdornment,
  Modal,
  Box,
  useMediaQuery,
  Divider,
} from "@mui/material";
import axios from "axios";
import { GoogleOAuthProvider, useGoogleLogin } from "@react-oauth/google";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import BottomImage from "../../components/LoginPages/bottomimage";
import HeaderApp from "../../components/LoginPages/header";
import "./style.css";
import { esignToolApi } from "../../services/esignApi";
import Loader from "../../components/Loader";
import { signupUser } from "../../store/reducers/signupSlice";
import Cookies from "js-cookie";
import { companyProfile } from "../../store/reducers/profileSlice";

const SignInBox = ({
  signInOpen,
  setSignInOpen,
  setSignInOtpOpen,
  setLoginOpen,
}) => {
  const [email, setEmail] = useState("");
  const [helperText, setHelperText] = useState({ email: "", gmail: "" });
  const [errors, setErrors] = useState({ email: "", gmail: "" });
  const [loader, setLoader] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { user, isAuthenticated } = useSelector((state) => state.auth);
  const CLIENT_ID =
    "24660824558-kmbv1lh18n9e6urnqgrl32urhpql4in4.apps.googleusercontent.com";
  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down("sm"));
  const isMediumScreen = useMediaQuery((theme) =>
    theme.breakpoints.between("sm", "md")
  );
  const isLargeScreen = useMediaQuery((theme) => theme.breakpoints.up("md"));

  const GoogleLoginButton = () => {
    const login = useGoogleLogin({
      onSuccess: (tokenResponse) => {
        fetch("https://www.googleapis.com/oauth2/v3/userinfo", {
          headers: { Authorization: `Bearer ${tokenResponse.access_token}` },
        })
          .then((res) => res.json())
          .then((data) => {
            console.log("User Info:", data);
            setErrors((prevErrors) => ({
              ...prevErrors,
              gmail: "",
            }));
            setHelperText((prevHelperText) => ({
              ...prevHelperText,
              gmail: "",
            }));
            hanndleGoogleSignIn(data);
          })
          .catch((err) => console.error(err));
      },
      onError: () => {
        console.error("Login Failed");
      },
    });

    return (
      <Button
        onClick={() => login()}
        variant="outlined"
        className="googleSignINbtn"
      >
        <img
          src={`${process.env.PUBLIC_URL}/images/google.png`}
          alt="Google Logo"
          style={{ height: 23 }}
        />
        <span>Sign up with Google</span>
      </Button>
    );
  };

  const hanndleGoogleSignIn = async (data) => {
    console.log(data);
    if (data?.email) {
      const curlPayload = {
        customer_name: data.name,
        gstno: "",
        add1: "",
        add2: "",
        add3: "",
        add4: "",
        state: "",
        customer_type: "indivisual",
        email: data.email,
        mobile: "",
      };
      try {
        const curlResponse = await axios.post(
          "https://invoice.meon.co.in/addcompanyoutside",
          new URLSearchParams(curlPayload),
          {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
              Authorization:
                "Bearer 12A9F8B3C5D6E7F8G9H0J1K2L3M4N5P6Q7R8S9T0U1V2W3X4Y5Z6A7B8C9D0E1F2G3H4",
            },
          }
        );
        if (!curlResponse.data.status) {
          console.log("Failed to add company. Please try again.");
          setLoader(false);
          return;
        }
        // console.log(curlResponse,curlResponse.data.customer_id)
        const { customer_id } = curlResponse.data;

        if (!customer_id) {
          console.log("Customer ID not received. Please try again.");
          setLoader(false);
          return;
        }

        const signupdata = {
          company_email: data?.email,
          company_name: data?.name,
          password: "",
          account_type: "Prepaid",
          admin_type: "user",
          esign_price: "20.00",
          customer_id: customer_id,
          credentials_type: "esign",
          is_google: true,
          visitor_id: Cookies.get("guid") || "",
        };
        try {
          console.log(signupdata);
          const result = await dispatch(signupUser(signupdata)).unwrap();
          console.log("Signup successful:", result);
          Cookies.set("c_d_token", result?.credentials?.token, {
            expires: 7,
            secure: true,
            sameSite: "Strict",
          });
          dispatch(companyProfile());
          // const redirectTo = location.state?.from?.pathname || "/";
          // navigate(redirectTo, { replace: true });
        } catch (error) {
          console.error("Signup failed:", error);
          setLoader(false);
          setErrors((prevErrors) => ({
            ...prevErrors,
            gmail: error?.msg,
          }));
          setHelperText((prevHelperText) => ({
            ...prevHelperText,
            gmail: error?.msg,
          }));
        }
      } catch (error) {
        setLoader(false);
        console.error("Error verifyotp:", error);
      }
    }
  };

  // Email validation function
  const validateEmail = (value) => {
    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailPattern.test(value);
  };

  const validateInputs = () => {
    let newErrors = { email: "" };
    let newHelperText = { email: "" };
    let isValid = true;

    if (!email) {
      newErrors.email = "Email is required";
      newHelperText.email = "Email is required";
      isValid = false;
    }

    if (!validateEmail(email) && email) {
      newErrors.email = "Invalid email address";
      newHelperText.email = "Invalid email address";
      isValid = false;
    }

    setErrors(newErrors);
    setHelperText(newHelperText);
    return isValid;
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    if (name === "email") {
      setEmail(value);
      if (!validateEmail(value) && value) {
        setErrors((prevErrors) => ({
          ...prevErrors,
          email: "Invalid email address",
          gmail: "",
        }));
        setHelperText((prevHelperText) => ({
          ...prevHelperText,
          email: "Invalid email address",
          gmail: "",
        }));
      } else {
        setErrors((prevErrors) => ({ ...prevErrors, email: "", gmail: "" }));
        setHelperText((prevHelperText) => ({
          ...prevHelperText,
          email: "",
          gmail: "",
        }));
      }
    }
  };

  const handleSubmit = async () => {
    if (validateInputs()) {
      setLoader(true);
      try {
        const response = await esignToolApi.signupSendOtp(email);
        console.log(response);
        setLoader(false);
        if (response && response?.status === true) {
          localStorage.setItem("email", email);
          setSignInOpen(false);
          setSignInOtpOpen(true);
          // setTimeout(() => {
          //   console.log("Navigating to verify-otp...");
          //   window.location.replace(`${process.env.PUBLIC_URL}/verify-otp`)
          // }, 100);
        } else {
          console.error("Failed to verify otp:", response);
          setErrors((prevErrors) => ({
            ...prevErrors,
            email: response?.message,
          }));
          setHelperText((prevHelperText) => ({
            ...prevHelperText,
            email: response?.message,
          }));
        }
      } catch (error) {
        setLoader(false);
        console.error("Error verifyotp:", error);
      }
    }
  };

  return (
    <>
      <Modal
        open={signInOpen}
        onClose={() => setSignInOpen(false)}
        sx={{ backdropFilter: "blur(5px)", background: "#1D1D1D99" }}
        slotProps={{
          backdrop: {
            sx: {
              backgroundColor: "transparent",
            },
          },
        }}
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: isSmallScreen ? "90%" : "500px",
            maxHeight: "600px",
            backgroundColor: "#fff",
            boxShadow: 24,
            overflow: "auto",
            borderRadius: "20px",
          }}
        >
          <Paper
            elevation={3}
            sx={{
              background: "#fffff",
              position: "relative",
              zIndex: 1,
              borderRadius: "15px",
              boxShadow: "rgba(0, 0, 0, 0.1) 0px 7px 49px 0px",
            }}
          >
            <Box
              sx={{
                padding: "1.6em 3em",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <Typography
                variant="h5"
                gutterBottom
                sx={{ fontWeight: 700, fontSize: "24px", marginBottom: "2px" }}
              >
                Do the unimaginable!
              </Typography>
              <Typography
                gutterBottom
                sx={{ color: "#565555", fontSize: "18px", fontWeight: "400" }}
              >
                Explore for free now!
              </Typography>

              <GoogleOAuthProvider clientId={CLIENT_ID}>
                <GoogleLoginButton />
              </GoogleOAuthProvider>
              {errors.gmail && (
                <Typography
                  sx={{
                    color: "#FF6666",
                    fontSize: "12px",
                    mt: 0.5,
                    mb: 0,
                    marginRight: "auto",
                  }}
                >
                  {helperText.gmail}
                </Typography>
              )}
              <Typography
                variant="h5"
                sx={{
                  my: 2,
                  color: "#C0C0C0",
                  fontSize: "16px",
                  fontWeight: "400",
                }}
              >
                OR
              </Typography>

              <TextField
                placeholder="Email address"
                name="email"
                type="email"
                variant="outlined"
                fullWidth
                value={email}
                onChange={(e) => {
                  handleChange(e);
                }}
                error={!!errors.email}
                sx={{
                  boxSizing: "border-box",
                  borderRadius: "10px",
                  backgroundColor: "#fff",
                  borderColor: "#C0C0C0",
                  borderWidth: "5px",
                  "& .MuiOutlinedInput-root": {
                    borderColor: errors.email ? "#FF6666" : "#C0C0C0",
                    backgroundColor: errors.email ? "#FFF1F1" : "none",
                    "&:hover fieldset": {
                      borderColor: errors.email ? "#FF6666" : "#C0C0C0",
                    },
                    "&.Mui-focused fieldset": {
                      borderColor: errors.email ? "#FF6666" : "#C0C0C0",
                    },
                  },
                  "& .MuiFormHelperText-root": {
                    color: "#FF6666",
                  },
                }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <img
                        src={`${process.env.PUBLIC_URL}/images/mail.svg`}
                        alt="Email Icon"
                        style={{ width: 18, height: 18 }}
                      />
                    </InputAdornment>
                  ),
                  sx: {
                    borderRadius: "10px",
                    height: 45,
                    fontSize: "16px",
                    fontWeight: email ? "600" : "400",
                  },
                }}
              />

              {errors.email && (
                <Typography
                  sx={{
                    color: "#FF6666",
                    fontSize: "12px",
                    mt: 0.5,
                    mb: 0,
                    marginRight: "auto",
                  }}
                >
                  {helperText.email}
                </Typography>
              )}

              <Button
                variant="contained"
                sx={{
                  mt: 3,
                  width: "100%",
                  height: 45,
                  color: "#fff",
                  background: "#185CB7",
                  textTransform: "none",
                  fontSize: "16px",
                  borderRadius: "10px",
                  fontWeight: "600",
                  "&:hover": { background: "#185CB7" },
                }}
                onClick={handleSubmit}
              >
                Sign up
              </Button>

              <Typography
                sx={{
                  fontSize: "10px",
                  color: "#7F7F7F",
                  my: 2,
                  textAlign: "center",
                }}
              >
                This site is protected by reCAPTCHA and the{" "}
                <a
                  href="https://policies.google.com/privacy"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ color: "#185CB7" }}
                >
                  Google Privacy Policy
                </a>{" "}
                and{" "}
                <a
                  href="https://policies.google.com/terms"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ color: "#185CB7" }}
                >
                  Terms of Service
                </a>{" "}
                apply.
              </Typography>
            </Box>
            <Divider sx={{ width: "100%" }} />
            <Box
              sx={{
                p: "26px 0",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <Typography
                gutterBottom
                sx={{
                  fontWeight: 400,
                  fontSize: "16px",
                  color: "#1D1D1D",
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                  mb: 0,
                }}
              >
                Already have an account?{" "}
                <span
                  style={{
                    fontWeight: 600,
                    fontSize: "16px",
                    color: "#185CB7",
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    setLoginOpen(true);
                    setSignInOpen(false);
                  }}
                >
                  Log In
                </span>
              </Typography>
            </Box>
          </Paper>
        </Box>
      </Modal>
      {loader && <Loader />}
    </>
  );
};

export default SignInBox;
